import { useSelector, useDispatch } from "react-redux";
import { toggleTheme } from "../../redux/Slices/ThemeSlice";
import { RootState, AppDispatch } from "../../redux/store";
import styles from "../../../src/layouts/Header/Header.module.scss";

export default function ThemeToggle() {
  const theme = useSelector((state: RootState) => state.theme.mode);
  const dispatch = useDispatch<AppDispatch>();
  const isOn = theme === "dark";

  return (
    <div className={styles.themeToggleWrapper}>
      <button
        onClick={() => dispatch(toggleTheme())}
        className={`${styles.toggleSwitch} ${isOn ? styles.on : styles.off}`}
        aria-label="Gecə/Gündüz rejimi"
      >
        <span className={styles.slider}></span>
      </button>
    </div>
  );
}
